export const style = {
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      color: 'primary.text',
      '& .MuiTypography-root': {
        color: 'primary.text',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 120,
      },
      '& svg': {
        fontSize: '30px',
      },
    },
  },
  Typography: {
    sx: {
      color: 'primary.text',
    },
  },
} as const;
